import { useEffect, useState } from 'react';

import type { Invitation, SiteWithPermissions } from '@sine/sine-core-api-types';

export function useSiteAndVisitorTypeSelection(
  invitation: Invitation | undefined,
  allSites: Array<SiteWithPermissions>,
) {
  const [selectedSiteId, setSelectedSiteId] = useState(invitation ? invitation.site : allSites[0]?.id);
  const [selectedVisitorTypeId, setSelectedVisitorTypeId] = useState(
    invitation ? invitation.visitorType : allSites[0]?.visitorTypes[0]?.id,
  );

  useEffect(() => {
    if (!invitation && allSites.length > 0) {
      if (!selectedSiteId) {
        setSelectedSiteId(allSites[0].id);
      }
      if (!selectedVisitorTypeId) {
        setSelectedVisitorTypeId(allSites[0].visitorTypes[0]?.id);
      }
    }
  }, [allSites, invitation]);

  return {
    selectedSiteId,
    setSelectedSiteId,
    selectedVisitorTypeId,
    setSelectedVisitorTypeId,
  };
}
